import type { SeriesRecord } from '@/features/charts/types/chartData';
import getDecimalPlaces from '@/shared/lib/format/getDecimalPlaces';

export const getFieldDecimalPlaces = (fieldValue: SeriesRecord[] | undefined[]): number =>
  fieldValue[0]?.[1] ? getDecimalPlaces(fieldValue[0][1]) : 0;
